<template>
  <div class="columns is-centered">
    <div class="column is-two-thirds-tablet is-half-desktop">
      <user-type-tabs
        :values="tabs.values"
        :labels="tabs.labels"
        :active-tab="tabs.activeTab"
        :activate-tab="activateTab"
      />
      <div v-if="tabs.activeTab === 'journeys'">
        <journeys-reset-password-request />
      </div>
      <div v-if="tabs.activeTab === 'business'">
        <business-reset-password-request />
      </div>
    </div>
  </div>
</template>

<script>
import { isLoggedIn } from 'router/helpers';
import { defaultAuthState } from 'utils/auth';
import BusinessResetPasswordRequest from 'components/auth/BusinessResetPasswordRequest';
import JourneysResetPasswordRequest from 'components/auth/JourneysResetPasswordRequest';
import UserTypeTabs from 'components/auth/UserTypeTabs';

export default {
  components: {
    BusinessResetPasswordRequest,
    JourneysResetPasswordRequest,
    UserTypeTabs,
  },

  data() {
    return defaultAuthState();
  },

  beforeRouteEnter(to, from, next) {
    return isLoggedIn() ? next(false) : next();
  },

  methods: {
    activateTab(tabName) {
      if (tabName !== this.tabs.activeTab) {
        this.tabs.activeTab = tabName;

        router.push({ query: { tab: tabName } });
      }
    },
  },
};
</script>
